import {
  IconTwitter,
  IconInstagram,
  IconTelegram,
  IconLinkedin,
} from './icons';
import styled from '@emotion/styled';
import { Icon } from './styles';
import { __t } from './i18n';
import { MessageId } from './i18n/LanguageManager';

const Container = styled.div<{ large?: boolean; }>(({ theme, large }) => ({
  display: 'flex',
  border: '1px solid',
  borderRadius: theme.radius[large ? 'medium' : 'default'],
  lineHeight: theme.font.lineHeight.compact,
}));

const SocialIcon = styled.a<{ large?: boolean; }>(({ large }) => ({
  display: 'flex',
  alignItems: 'center',
  borderLeft: '1px solid',
  padding: '0 1em',
  margin: '.25em 0',
  fontSize: `${large ? 2 : 1}rem`,
  [`${Icon}`]: {
    margin: 0,
  },
  '&:last-of-type': { border: 'none' },
}));

const links = [
  {
    name: 'linkedin',
    label: 'social.linkedin' as MessageId,
    icon: <IconLinkedin />,
    href: 'https://www.linkedin.com/company/filmnetir/',
  },
  {
    name: 'twitter',
    label: 'social.twitter' as MessageId,
    icon: <IconTwitter />,
    href: 'https://twitter.com/filmnetofficial',
  },
  {
    name: 'telegram',
    label: 'social.telegram' as MessageId,
    icon: <IconTelegram />,
    href: 'https://t.me/filmnetofficial',
  },
  {
    name: 'instagram',
    label: 'social.instagram' as MessageId,
    icon: <IconInstagram />,
    href: 'https://instagram.com/filmnet.ir_',
  },
];

export default function SocialLinks({ large }: { large?: boolean; }) {
  return (
    <Container large={large}>
      {links.map(({ name, href, icon, label }) => (
        <SocialIcon key={name} href={href} large={large} aria-label={__t(label)}>
          <Icon cursor="pointer">{icon}</Icon>
        </SocialIcon>
      ))}
    </Container>
  );
}
